import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { errorMessage } from "../../api/client";
import { punchApi, type CorrectionView } from "../../api/clock";
import { Button, ErrorText, FullScreenLoader } from "../../components/ui";
import { PunchShell } from "./punchParts";

export default function CorrectionPage() {
  const { token = "" } = useParams();
  const [view, setView] = useState<CorrectionView | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    punchApi.correction(token).then(setView).catch((e) => setError(errorMessage(e)));
  }, [token]);
  const submit = async () => {
    setBusy(true);
    setError(null);
    try {
      setView(await punchApi.submitCorrection(token, note));
    } catch (e) {
      setError(errorMessage(e));
    } finally {
      setBusy(false);
    }
  };
  if (!view && !error) return <FullScreenLoader />;
  return (
    <PunchShell testId="correction-page" eyebrow="Correction request">
      {view && (
        <>
          <p className="text-lg text-white">Hi {view.first_name}.</p>
          <p data-testid="correction-summary" className="text-sm text-zinc-300">
            Your clock-{view.type.toLowerCase()} text at <strong className="text-white">{view.sms_received_local}</strong> is saved and waiting for an admin review.
          </p>
          {view.used ? (
            <p data-testid="correction-done" className="rounded-sm border border-emerald-400/30 bg-emerald-400/5 p-4 text-sm text-zinc-200">This link was already used. Your note was sent to the admin, and they'll review your time.</p>
          ) : (
            <div className="space-y-3">
              <label htmlFor="correction-note" className="label-caps text-zinc-400">Tell the admin what happened</label>
              <textarea id="correction-note" rows={4} maxLength={1000} value={note} onChange={(e) => setNote(e.target.value)}
                className="w-full rounded-sm border border-white/15 bg-surface p-3 text-sm text-white" data-testid="correction-note-input" />
              <Button className="h-14 w-full rounded-[16px] text-base" loading={busy} onClick={submit} data-testid="correction-submit-button">Send correction request</Button>
            </div>
          )}
        </>
      )}
      <ErrorText message={error} testId="correction-error" />
    </PunchShell>
  );
}
